export enum IFTAGrade {
    GradeI = 0,
    GradeII = 1,
    GradeIII = 2
}